export const SCHEDULE_PATH_NAME = '/shifts';
export const ONBOARDING_TOAST_ID = 'onboarding-checklist';
